import React from "react";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { getTransferList } from "@/api/new-api/staff-management/profile";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import FormInputField from "@/components/lib/from-input-field";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import { Separator } from "@/components/ui/separator";
import { TabsContent } from "@/components/ui/tabs";
import { Trash2, PenLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import useAuth from "@/hooks/useAuth";

function Transfer() {

  const {user} = useAuth()
  const [openTransferDialog, setOpenTransferDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transferList, setTransferList] = useState([]);

  useEffect(() => {
    const fetchTransfer = async () => {
      setLoading(true);
      try {
        const res = await getTransferList(user?.restaurant_id);
        if (res.status === "success") {
          setTransferList(res.data.transfers);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchTransfer();
  }, [user?.restaurant_id]);

  const onDialog = () => {
    setOpenTransferDialog(true);
  };

  console.log(transferList);

  const offDialog = () => {
    setOpenTransferDialog(false);
  };

  return (
    <TabsContent className="mt-5" value="transfer">
      <div className="mb-4 flex justify-end">
        <Button onClick={onDialog} className="bg-cyellow text-black">
          Transfer
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>From</TableHead>
            <TableHead>To</TableHead>
            <TableHead>Note</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {transferList?.map((item, i) => (
            <TableRow key={i}>
              <TableCell>{item.transfer_date}</TableCell>
              <TableCell>{item.from_restaurant_name}</TableCell>
              <TableCell>{item.to_restaurant_name}</TableCell>
              <TableCell>{item.reason}</TableCell>
              <TableCell className="text-right flex items-center justify-end">
                <div className="flex items-center gap-3">
                  <PenLine className="text-cyellow cursor-pointer" size={18} />
                  <Trash2 className="text-cred cursor-pointer" size={18} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TransferDialog
        openTransferDialog={openTransferDialog}
        offDialog={offDialog}
      />
    </TabsContent>
  );
}

export default Transfer;

export function TransferDialog({ openTransferDialog, offDialog }) {
  const form = useForm({
    resolver: zodResolver(transferSchema),
    defaultValues: {
      emploayId: "",
      from: "",
      to: "",
      note: undefined,
    },
  });

  const addTransfer = (data) => {
    console.log(data);
  };

  return (
    <Dialog open={openTransferDialog} onOpenChange={offDialog}>
      <DialogContent className="sm:max-w-[800px]">
        <div className="py-5 flex flex-col">
          <DialogTitle className="text-lg absolute top-4 font-medium">
            New Transfer
          </DialogTitle>
          <Separator className="mt-4" />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(addTransfer)}
              className="flex flex-col gap-5 mt-6"
            >
              <FormInputField
                name="emploayId"
                style="bg-cblack3"
                placeholder={"Emploay ID/Name"}
                form={form}
                type="text"
                label={"Emploay ID/Name"}
              />
              <div className="bg-cblack5 space-y-3 p-2 rounded-md">
                <Label>Form</Label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <FormInputField
                    name="from"
                    style="bg-cblack3"
                    placeholder={"Select here"}
                    form={form}
                    type="text"
                    label={"Business"}
                  />

                  <FormInputField
                    name="to"
                    placeholder={"Select here"}
                    form={form}
                    type="text"
                    style="bg-cblack3"
                    label={"Branch Name"}
                  />
                </div>
              </div>
              <div className="bg-cblack5 space-y-3 p-2 rounded-md">
                <Label>To</Label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <FormInputField
                    name="from"
                    style="bg-cblack3"
                    placeholder={"Select here"}
                    form={form}
                    type="text"
                    label={"Business"}
                  />
                  <FormInputField
                    name="to"
                    placeholder={"Select here"}
                    form={form}
                    type="text"
                    style="bg-cblack3"
                    label={"Branch Name"}
                  />
                </div>
              </div>

              <FormInputField
                name="note"
                style="bg-cblack3 h-36"
                placeholder={"Write here"}
                form={form}
                type="textarea"
                label={"Note"}
              />

              <Button className="bg-cyellow w-full mt-5 text-cblack">
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const transferSchema = z.object({
  emploayId: z.string().min(1, "Emploay name is required"),
  from: z.string().min(1, "Required"),
  to: z.string().min(1, "Required"),
  Note: z.string().optional(),
});
